import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "default-table-area style-two top-instructors" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle border-0" }
const _hoisted_6 = { class: "mb-0 fs-14 fw-medium" }
const _hoisted_7 = { class: "text-body" }
const _hoisted_8 = ["aria-valuenow"]
const _hoisted_9 = { class: "p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PaginationTwo = _resolveComponent("PaginationTwo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"p-4\" data-v-16e76fc4><div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3\" data-v-16e76fc4><h3 class=\"mb-0\" data-v-16e76fc4>Student’s Progress</h3><div class=\"dropdown action-opt\" data-v-16e76fc4><button class=\"btn bg-transparent p-0\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\" data-v-16e76fc4><i data-feather=\"more-horizontal\" data-v-16e76fc4></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\" data-v-16e76fc4><li data-v-16e76fc4><a class=\"dropdown-item\" href=\"javascript:;\" data-v-16e76fc4><i data-feather=\"clock\" data-v-16e76fc4></i> Today </a></li><li data-v-16e76fc4><a class=\"dropdown-item\" href=\"javascript:;\" data-v-16e76fc4><i data-feather=\"pie-chart\" data-v-16e76fc4></i> Last 7 Days </a></li><li data-v-16e76fc4><a class=\"dropdown-item\" href=\"javascript:;\" data-v-16e76fc4><i data-feather=\"rotate-cw\" data-v-16e76fc4></i> Last Month </a></li><li data-v-16e76fc4><a class=\"dropdown-item\" href=\"javascript:;\" data-v-16e76fc4><i data-feather=\"calendar\" data-v-16e76fc4></i> Last 1 Year </a></li><li data-v-16e76fc4><a class=\"dropdown-item\" href=\"javascript:;\" data-v-16e76fc4><i data-feather=\"bar-chart\" data-v-16e76fc4></i> All Time </a></li><li data-v-16e76fc4><a class=\"dropdown-item\" href=\"javascript:;\" data-v-16e76fc4><i data-feather=\"eye\" data-v-16e76fc4></i> View </a></li><li data-v-16e76fc4><a class=\"dropdown-item\" href=\"javascript:;\" data-v-16e76fc4><i data-feather=\"trash\" data-v-16e76fc4></i> Delete </a></li></ul></div></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "Name"),
                _createElementVNode("th", { scope: "col" }, "Course Name"),
                _createElementVNode("th", { scope: "col" }, "Status")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.slice(0, 6), (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/lms/instructors",
                      class: "d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h6", _hoisted_6, _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", _hoisted_7, _toDisplayString(item.courseName), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['progress bg-opacity-10', item.status.className]),
                      role: "progressbar",
                      "aria-label": "Example with label",
                      "aria-valuenow": item.status.percentage,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100",
                      style: {"height":"5px"}
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                        'progress-bar rounded-pill',
                        item.status.className,
                      ]),
                        style: _normalizeStyle({
                        width: item.status.percentage + '%',
                        height: '5px',
                      })
                      }, null, 6)
                    ], 10, _hoisted_8)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_PaginationTwo, {
          items: "5",
          total: _ctx.items.length
        }, null, 8, ["total"])
      ])
    ])
  ]))
}